// Mobile-number normalisation for AU / IN / US numbers.
//
// Lifted verbatim from the copy in Forms/GrantSingleMemberForm.js (which itself
// mirrors SinglePassCreation.js) so a third page doesn't need a third copy.
// Those two pages still carry their own copies — this is additive, and adopting
// it there is a separate change, deliberately not bundled with a new feature.

/**
 * Normalise a typed mobile number for the selected country.
 *
 * Returns { countryCode, localNumber, fullNumber } or null when invalid, so the
 * caller can treat null as "failed validation".
 */
export function normalizeMobileInput(value, selectedCountryCode) {
    if (!value) return null;

    const digits = value.replace(/\D/g, '');
    const countryCode = String(selectedCountryCode || '').replace(/\D/g, '');

    let localNumber = digits;

    if (countryCode === '91') {
        if (localNumber.startsWith('91')) {
            if (localNumber.length === 12) {
                localNumber = localNumber.slice(2);
            } else {
                return null;
            }
        }

        if (localNumber.startsWith('0') && localNumber.length === 11) {
            localNumber = localNumber.slice(1);
        }

        if (!/^[6789]\d{9}$/.test(localNumber)) return null;

        return { countryCode: '91', localNumber, fullNumber: `+91${localNumber}` };
    }

    if (countryCode === '61') {
        if (localNumber.startsWith('61') && localNumber.length >= 11) {
            localNumber = localNumber.slice(2);
        }

        if (/^4\d{8}$/.test(localNumber)) {
            localNumber = `0${localNumber}`;
        }

        if (!/^04\d{8}$/.test(localNumber)) return null;

        return { countryCode: '61', localNumber, fullNumber: `+61${localNumber.slice(1)}` };
    }

    if (countryCode === '1') {
        if (localNumber.startsWith('1') && localNumber.length === 11) {
            localNumber = localNumber.slice(1);
        }

        if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(localNumber)) return null;

        return { countryCode: '1', localNumber, fullNumber: `+1${localNumber}` };
    }

    return null;
}

/** Only AU (61), IN (91), and US (1) are offered; anything else falls back to AU. */
export function resolveDialCode(rawDialCode) {
    const code = String(rawDialCode || '').replace(/\D/g, '');
    if (code === '91' || code === '61' || code === '1') return code;
    return '61';
}
